import { AuthSuccessResponse } from "../services/auth.service";

export const authKeys = {
  all: ["auth"] as const,
  me: () => [...authKeys.all, "me"] as const,
} as const;

export type AuthResponseType = AuthSuccessResponse;
